import { MapPin, User, Timer, Thermometer, Calendar } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const sessionSchema = defineSchema({
  id: 'sessions',
  title: 'filter.schema.sessions.title',
  subtitle: 'filter.schema.sessions.subtitle',
  defaultField: 'name',
  fields: {
    name: {
      key: 'name',
      label: 'filter.field.trackDriver',
      type: 'text',
      icon: MapPin,
      placeholder: 'filter.placeholder.trackDriver',
      description: 'filter.desc.trackDriver',
      example: 'name:WOHLEN',
    },
    driver: {
      key: 'driver',
      label: 'filter.field.driver',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driver',
      description: 'filter.desc.driver',
      example: 'driver:Yanick',
    },
    laps: {
      key: 'laps',
      label: 'filter.field.laps',
      type: 'range',
      icon: Timer,
      unit: 'filter.unit.laps',
      min: 0,
      max: 100,
      description: 'filter.desc.laps',
      example: 'laps:>=5',
      presets: [
        { label: 'filter.preset.lapsShort', value: '5', operator: '<=' },
        { label: 'filter.preset.lapsMedium', value: '6', highValue: '15', operator: 'between' },
        { label: 'filter.preset.lapsLong', value: '15', operator: '>' },
      ],
    },
    temp: {
      key: 'temp',
      label: 'filter.field.temp',
      type: 'range',
      icon: Thermometer,
      unit: '°C',
      min: -10,
      max: 50,
      description: 'filter.desc.temp',
      example: 'temp:15..25',
      presets: [
        { label: 'filter.preset.tempCool', value: '15', operator: '<' },
        { label: 'filter.preset.tempMild', value: '15', highValue: '25', operator: 'between' },
        { label: 'filter.preset.tempWarm', value: '25', operator: '>=' },
      ],
    },
    season: {
      key: 'season',
      label: 'filter.field.season',
      type: 'number',
      icon: Calendar,
      description: 'filter.desc.season',
      example: 'season:2026',
      presets: [
        { label: '2026', value: '2026', operator: '=' },
        { label: '2025', value: '2025', operator: '=' },
        { label: '2024', value: '2024', operator: '=' },
      ],
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:-30d',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last7d', value: '-7d' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'WOHLEN laps:>=5', desc: 'search.example.wohlenLaps' },
    { q: 'driver:Yanick from:-30d', desc: 'search.example.yanick30d' },
    { q: 'temp:15..25 laps:>3', desc: 'search.example.tempLaps' },
    { q: '(WOHLEN OR MAGNY) from:-1y', desc: 'search.example.wohlenMagny' },
  ],
});

